export default {
    methods : {
        getProfileImage(item) {
            if(item.medias == null) item.medias = []
            //find first an item with the same type and replace it
            var mediaIndex = item.medias.findIndex(m=>m.typeId == 1)
            if(mediaIndex !== undefined && mediaIndex !== -1) {
                var media = item.medias[mediaIndex]
                // console.log(media)
                return media.url
            }
        }
    }
}